import { HqlCode } from '@/components/hql/HqlCode';
import { QueryFacts } from '@/components/hql/QueryFacts';
import { MetadataItem } from '@/components/MetadataItem';
import { describeCoveredUnits } from '@/lib/hqlFormat';
import type { HomeEvalResultV2 } from '@rock/types';
import type { FC } from 'react';

/**
 * Why an evaluation created a consideration: the approved query, the units the consideration covers, and
 * the facts the query read, each unit marked matched or not. A follow-up one-time action covers only the
 * matched units no earlier action recorded.
 */
export const QueryEvalDetails: FC<{ result: HomeEvalResultV2 }> = ({ result }) => (
    <div className="space-y-4">
        <MetadataItem label="Query" value={<HqlCode query={result.query} block />} />
        <MetadataItem label="Covers" value={describeCoveredUnits(result.coveredEquipmentIds, result.facts.equipment)} />
        <QueryFacts facts={result.facts} matched={new Set(result.matchedEquipmentIds)} />
    </div>
);
